import React, { Component } from 'react';
import { Menu, Image, Icon, Responsive } from 'semantic-ui-react';
import { configureAnchors, goToAnchor } from 'react-scrollable-anchor';
import { Link } from 'react-router-dom';
import logo from '../images/logo.png';

const headerTopStyle = {
  backgroundColor: 'rgba(255,255,255,0.5)',
  height: '120px'
};

const NavItem = ({ link, active, name, icon, text, onClick, isHome }) => {
  if (isHome) {
    return (
      <Menu.Item name={name} active={active} onClick={onClick}>
        {' '}
        <Icon name={icon} />
        <Responsive minWidth={769}> {text} </Responsive>
      </Menu.Item>
    );
  }
  return (
    <Menu.Item as={Link} to={link} name={name} active={active}>
      {' '}
      <Icon name={icon} />
      <Responsive minWidth={769}> {text} </Responsive>
    </Menu.Item>
  );
};

class HeaderNav extends Component {
  componentDidMount() {
    configureAnchors({ offset: -50 });
  }
  handleItemClick = (e, { name }) => {
    goToAnchor(name, false);
  };

  renderNav = () => {
    return (
      <React.Fragment>
        <NavItem
          link={'/#Home'}
          name="Home"
          active={!this.props.headerTop && this.props.active === 'Home'}
          icon="home"
          text="ACCUEIL"
          onClick={this.handleItemClick}
          isHome={this.props.isHome}
        />
        <NavItem
          link={'/#About'}
          name="About"
          active={!this.props.headerTop && this.props.active === 'About'}
          icon="question circle"
          text="À PROPOS"
          onClick={this.handleItemClick}
          isHome={this.props.isHome}
        />
        <NavItem
          link={'/#Download'}
          name="Download"
          active={!this.props.headerTop && this.props.active === 'Download'}
          icon="mobile alternate"
          text="TÉLÉCHARGEMENT"
          onClick={this.handleItemClick}
          isHome={this.props.isHome}
        />
        <NavItem
          link={'/#Contact'}
          name="Contact"
          active={!this.props.headerTop && this.props.active === 'Contact'}
          icon="envelope"
          text="CONTACT"
          onClick={this.handleItemClick}
          isHome={this.props.isHome}
        />
        <Menu.Item as={Link} to="/controle" name="Controle" active={false}>
          <Icon name="check circle" />
          <Responsive minWidth={769}>CONTRÔLE</Responsive>
        </Menu.Item>
      </React.Fragment>
    );
  };
  render() {
    return (
      <div>
        <Responsive minWidth={769}>
          <Menu
            id="menu"
            icon="labeled"
            as="header"
            fixed="top"
            borderless
            style={
              this.props.headerTop
                ? headerTopStyle
                : { backgroundColor: 'white' }
            }
          >
            <Menu.Header style={{ width: '205px' }}>
              <Image
                src={logo}
                className="logo"
                style={
                  this.props.headerTop
                    ? { height: '100px' }
                    : { height: '60px' }
                }
              />{' '}
            </Menu.Header>
            {this.renderNav()}
          </Menu>
        </Responsive>
        <Responsive maxWidth={768}>
          <Menu
            compact
            id="menu"
            icon="labeled"
            as="header"
            widths={5}
            fixed="top"
            borderless
            style={{ backgroundColor: 'white' }}
          >
            {this.renderNav()}
          </Menu>
        </Responsive>
      </div>
    );
  }
}

export default HeaderNav;



// WEBPACK FOOTER //
// ./src/components/HeaderNav.js